<script lang="jsx">
  export default {
    name: 'YdLine',
    props: {
      size: {
        type: Number,
        default: 1
      },
      direction: {
        type: String,
        // horizontal
        // vertical
        default: 'vertical'
      },
      // 分割线是否可有文字
      content: {
        type: String,
        default: ''
      },
      contentPosition: {
        type: String,
        // left
        // right
        // center
        default: 'left'
      },
      type: {
        type: String,
        // solid
        // dashed
        default: 'dashed'
      },
      customStyle: {
        type: Object,
        default: () => {
          return {
            color: '#ddd',
            borderColor: '#ddd'
          }
        }
      }
    },
    render() {
      const { size, direction, type, content, contentPosition, customStyle } = this
      const setStyle = () => {
        const styles = {}
        if (direction === 'horizontal') {
          styles.borderTopStyle = type
          styles.borderTopWidth = size + 'px'
          styles.borderTopColor = customStyle.borderColor
          styles.width = '100%'
        } else {
          styles.height = '100%'
          styles.borderLeftStyle = type
          styles.borderLeftWidth = size + 'px'
          styles.borderLeftColor = customStyle.borderColor
        }
        return styles
      }
      return (
        <div
          class={{
            'line padding-y-10 position-relative': true
          }}
        >
          <div
            style={setStyle()}
            class={{
              'line-border position-absolute': true
            }}
          ></div>
          {content && direction === 'horizontal' ? (
            <div
              v-if="content"
              style={{ color: customStyle.color }}
              class={{
                'line-content position-absolute': true,
                'line-content-left': contentPosition === 'left',
                'line-content-right': contentPosition === 'right',
                'line-content-center': contentPosition === 'center'
              }}
            >
              {content}
            </div>
          ) : null}
        </div>
      )
    }
  }
</script>
<style scoped lang="scss">
  .line {
    .line-border {
    }
    &-content {
      top: 0;
      bottom: 0;
      margin: auto;

      background-color: #fff;
      padding: 0 10px;
      font-size: 12px;
      line-height: 20px;
      color: #666;
      &-left {
        left: 10%;
      }
      &-center {
        left: 50%;
        transform: translateX(-50%);
      }
      &-right {
        right: 10%;
      }
    }
  }
</style>
